import { computed } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';
import { AppClaims } from '@/enums/ApplicationClaims.enum';

interface Claim {
  key: string;
  value: string;
}

function getRolesFromClaims(claims: Claim[]): string[] {
  return claims
    .filter((claim) => claim.key === AppClaims.AppRolesClaim)
    .flatMap((claim) => claim.value.split(','));
}

export function useRole() {
  const { user } = useAuth0();

  const roles = computed(() => {
    const claims = user.value?.['https://booster.co.nz/claims'] as Claim[] | undefined;
    if (!claims) return [];
    return getRolesFromClaims(claims);
  });

  function hasRole(required: string | string[]) {
    const requiredRoles = Array.isArray(required) ? required : [required];
    return roles.value.some((role) => requiredRoles.includes(role));
  }

  return {
    roles,
    hasRole,
  };
}
